import * as React from "react";
import { Mutation, MutationResult } from "react-apollo";
import {
  UpsertMailingListMutation,
  UpsertMailingListMutationVariables,
  MailingListCreateInput
} from "../../__generated__/types";
import { UPSERT_MAILINGLIST_MUTATION } from "./queries";
import { message } from "antd";
import { MailingListSubmit } from "src/components/MailingListDetails/MailingListDetails";
import { MAILING_LIST_QUERY } from "src/queries/MailingListQuery/queries";
import { MAILING_LISTS_QUERY } from "src/queries/MailingListsQuery/queries";

class UpsertMutation extends Mutation<
  UpsertMailingListMutation,
  UpsertMailingListMutationVariables
> {}

export interface Props {
  id: string | null;
  add?: boolean;
  children(
    upsert: (data: MailingListSubmit) => void,
    result: MutationResult<UpsertMailingListMutation>
  ): JSX.Element | null;
}

export interface State {}

export default class UpsertMailingList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <UpsertMutation
        mutation={UPSERT_MAILINGLIST_MUTATION}
        onCompleted={e =>
          message.success(
            `${e.upsertMailingList.description} ${
              this.props.add ? "created" : "updated"
            }`
          )
        }
        onError={e =>
          message.error(
            e.graphQLErrors[0] ? e.graphQLErrors[0].message : "Unknown error"
          )
        }
        refetchQueries={
          this.props.id
            ? [
                {
                  query: MAILING_LIST_QUERY,
                  variables: { id: this.props.id }
                },
                { query: MAILING_LISTS_QUERY }
              ]
            : [{ query: MAILING_LISTS_QUERY }]
        }
        awaitRefetchQueries={true}
      >
        {(update, result) => {
          const updateFn = (data: MailingListSubmit) => {
            const id = this.props.id || data.id;
            const input: MailingListCreateInput = {
              ...data,
              members_roles: {
                set: data.members_roles.map(r => ({ name: r }))
              },
              members_users: {
                set: data.members_users.map(u => ({ id: u }))
              }
            };

            update({
              variables: {
                id: id || "",
                create: this.props.add
                  ? input
                  : { address: data.address, description: data.description },
                update: this.props.add ? {} : input
              }
            });
          };
          return this.props.children(updateFn, result);
        }}
      </UpsertMutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/UpsertMailingList/UpsertMailingList.tsx